export type CreateInviteRequest = {
    inviteEmail: string,
    inviteRoleId: number,
    inviteSenderId: number,
    inviteWorkspaceId: number
};

export const InviteRequestInit: CreateInviteRequest = {
    inviteEmail: "",
    inviteRoleId: 0,
    inviteSenderId: 0,
    inviteWorkspaceId: 0
};
